import React from "react";
import ItemTable from "../ItemTable/ItemTable";
import PageTitle from "../Shared/PageTitle/PageTitle";

const Manage = () => {
  
  
 
  return (
    
      <>
      <PageTitle title="Manage"></PageTitle>
      <ItemTable></ItemTable>

      </>
    
  );
};

export default Manage;
